
import './styles/quasar.sass'
import lang from 'quasar/lang/de.js'
import '@quasar/extras/material-icons/material-icons.css'

// To be used on app.use(Quasar, { ... })
export default {
  config: {},
  plugins: {
  },
  lang: lang
}
